<template>
  <div class="header-pda d-flex between" :class="{'right': $route.path === '/pda-menu'}">
    <p v-show="$route.path !== '/pda-menu'" class="no-shrink">
      <span class="back" @click="goMenu()">
        <i class="el-icon-back"></i>
        <span>返回目录</span>
      </span>
    </p>
    <span v-show="$route.path !== '/pda-menu'" class="title">
      {{title}}
    </span>
    <p v-show="$route.path === '/pda-menu'" class="right">
      <span>{{user.name}}</span>
      <span class="logout" @click="handleLogout()">
        <i class="el-icon-switch-button">退出登录</i>
      </span>
    </p>
    <p v-show="$route.path !== '/pda-menu'" class="right text-btn no-shrink">
      <span @click="handleLogout()">{{user.name}}</span>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { userTokenKey, localLabelKey } from '@/utils/Config.js'
export default {
  name: 'HeaderPda',
  data() {
    return {
      title: '',
      socket: null
    }
  },
  computed: {
    ...mapGetters(['menu', 'user'])
  },
  watch: {
    '$route.path'() {
      this.getTitle()
    }
  },
  created() {
    this.getTitle()
  },
  mounted() {
    this.listenSocket()
  },
  methods: {
    async listenSocket() {
      // 监听socket
      this.socket = this.socket || await this.$socket()
      if (this.socket) {
        this.socket.on('logout', (msg) => {
          const token = this.$cookie.get(userTokenKey)
          if (msg !== token) {
            this.logout()
          }
        })
      }
    },
    goMenu() {
      this.$router.push('/pda-menu')
    },
    getTitle() {
      // 匹配页面标题
      if (this.menu && this.menu.length > 0) {
        this.menu.forEach(i => {
          i.children.forEach(c => {
            if (c.href === this.$route.path) {
              this.title = c.name
            }
          })
        })
      } else {
        setTimeout(() => {
          this.getTitle()
        }, 100)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    handleLogout() {
      // 退出
      this.$confirm('确定退出当前账号吗？')
      .then(() => {
        this.logout()
      })
    },
    logout() {
      this.$cookie.remove(userTokenKey)
      this.$router.replace('/login')
      this.$utils.delLocal(localLabelKey)
      if (this.socket) {
        this.socket.disconnect()
        setTimeout(() => {
          this.socket = null
        }, 800)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/common.scss';
  .header-pda {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    padding: 0 10px;
    .back {
      color: $main_color_deep;
      font-size: 16px;
      font-weight: 600;
    }
    .splitter {
      width: 1px;
      height: 18px;
      background-color: lightgray;
      margin: 0 18px;
    }
    .title {
      font-weight: bold;
      font-size: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: keep-all;
      padding: 0 20px;
    }
    .logout {
      margin-left: 20px;
      color: rgb(255, 87, 34);
    }
    .text-btn {
      color: $main_color_deep;
      font-weight: bold;
    }
  }
</style>